import { createContext, useContext } from 'react';

// True inside copies that are rendered only to be measured (e.g. LineClamp's hidden copies),
// so article bodies there skip loading videos and YouTube embeds.
const MediaMeasureContext = createContext<boolean>(false);

export const MediaMeasureProvider = MediaMeasureContext.Provider;

export const useIsMediaMeasure = () => useContext(MediaMeasureContext);
